import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import InstanceLayer from "../components/InstanceLayer";

const InstanceList = () => {
  return (
    <MasterLayout>
      <InstanceLayer />
    </MasterLayout>
  );
};

export default InstanceList;
